export const LOCALES = [
  { code: 'en', label: 'English', countryCode: 'gb', country: 'GB', currency: 'EUR' },
  { code: 'bg', label: 'Български', countryCode: 'bg', country: 'BG', currency: 'EUR' },
  { code: 'hu', label: 'Magyar', countryCode: 'hu', country: 'HU', currency: 'EUR' },
  { code: 'el', label: 'Ελληνικά', countryCode: 'gr', country: 'GR', currency: 'EUR' },
  { code: 'da', label: 'Dansk', countryCode: 'dk', country: 'DK', currency: 'EUR' },
  { code: 'ie', label: 'Gaeilge', countryCode: 'ie', country: 'IE', currency: 'EUR' },
  { code: 'es', label: 'Español', countryCode: 'es', country: 'ES', currency: 'EUR' },
  { code: 'it', label: 'Italiano', countryCode: 'it', country: 'IT', currency: 'EUR' },
  { code: 'lv', label: 'Latviešu', countryCode: 'lv', country: 'LV', currency: 'EUR' },
  { code: 'lt', label: 'Lietuvių', countryCode: 'lt', country: 'LT', currency: 'EUR' },
  { code: 'mt', label: 'Malti', countryCode: 'mt', country: 'MT', currency: 'EUR' },
  { code: 'de', label: 'Deutsch', countryCode: 'de', country: 'DE', currency: 'EUR' },
  { code: 'nl', label: 'Nederlands', countryCode: 'nl', country: 'NL', currency: 'EUR' },
  { code: 'pl', label: 'Polski', countryCode: 'pl', country: 'PL', currency: 'PLN' },
  { code: 'pt', label: 'Português', countryCode: 'pt', country: 'PT', currency: 'EUR' },
  { code: 'ro', label: 'Română', countryCode: 'ro', country: 'RO', currency: 'EUR' },
  { code: 'sk', label: 'Slovenčina', countryCode: 'sk', country: 'SK', currency: 'EUR' },
  { code: 'sl', label: 'Slovenščina', countryCode: 'si', country: 'SI', currency: 'EUR' },
  { code: 'fi', label: 'Suomi', countryCode: 'fi', country: 'FI', currency: 'EUR' },
  { code: 'fr', label: 'Français', countryCode: 'fr', country: 'FR', currency: 'EUR' },
  { code: 'hr', label: 'Hrvatski', countryCode: 'hr', country: 'HR', currency: 'EUR' },
  { code: 'cs', label: 'Čeština', countryCode: 'cz', country: 'CZ', currency: 'EUR' },
  { code: 'sv', label: 'Svenska', countryCode: 'se', country: 'SE', currency: 'EUR' },
  { code: 'et', label: 'Eesti', countryCode: 'ee', country: 'EE', currency: 'EUR' },
];
